module.exports = __webpack_public_path__ + "img/sTriMnky_350x350.9d36969f.jpg";